<template>
  <div
    v-if="isCategory"
    class="fi-mt-48"
  >
    <no-products-found-fi />
  </div>
  <div
    v-else
    class="fact-finder-no-results-fi"
  >
    <div
      v-if="noFilters"
      class="fact-finder-no-results-fi__search"
      :class="{ 'fact-finder-no-results-fi__search-full': showResultSuggestion }"
    >
      <text-input-fi
        v-model.trim="search"
        :placeholder="$dict.get('search.No-Results.Placeholder')"
        icon="search"
        class="fact-finder-no-results-fi__input"
        @keyup-enter="newSearch"
        @icon-clicked="newSearch"
      />
    </div>
    <div
      v-if="!showResultSuggestion"
      :class="{
        'fact-finder-no-results-fi__content': true,
        'fact-finder-no-results-fi__content--no-filters': noFilters,
      }"
    >
      <richtext-fi
        class="fact-finder-no-results-fi__suggestions"
        :html-content="fields.noResultsSuggestions"
      />
    </div>
  </div>
</template>

<script>
import { RichtextFi, TextInputFi } from 'atoms';
import { defineAsyncComponent } from 'vue';

const NoProductsFoundFi = defineAsyncComponent(
  () => import('@/components/shop-modules/product-list-view/NoProductsFoundFi.vue'),
);

export default {
  name: 'FactFinderNoResultsFi',
  components: {
    NoProductsFoundFi,
    RichtextFi,
    TextInputFi,
  },
  props: {
    fields: {
      type: Object,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    noFilters: {
      type: Boolean,
    },
    showResultSuggestion: {
      type: Boolean,
    },
    isCategory: Boolean,
  },
  emits: ['new-search'],
  data() {
    return {
      search: '',
    };
  },
  methods: {
    newSearch() {
      this.$emit('new-search', this.search);
    },
  },
};
</script>

<style src="./fact-finder-no-results-fi-unscoped" />

<style scoped src="./fact-finder-no-results-fi" />
